var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"tw-text-gray-800"},[_vm._v("Comment")]),_c('div',{staticClass:"tw-mt-0.5 tw-text-xs tw-text-gray-500"},[_vm._v("\n    "+_vm._s(_vm.event.label)+"\n  ")]),_c('base-button',{attrs:{"type":"text","size":"xs"},on:{"click":function($event){return _vm.$emit('editComment', _vm.event)}}},[_vm._v("Edit / Delete")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }